import { render, staticRenderFns } from "./status_avatar.vue?vue&type=template&id=0e00f56f&scoped=true&v-slot%3Adefault=%7B%20hover%20%7D&"
import script from "./status_avatar.vue?vue&type=script&lang=js&"
export * from "./status_avatar.vue?vue&type=script&lang=js&"
import style0 from "./status_avatar.vue?vue&type=style&index=0&id=0e00f56f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e00f56f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBadge,VBtn,VFadeTransition,VHover,VIcon,VImg,VOverlay,VTooltip})
